import {
  APP_CONTENT_LOADING,
  APP_CONTENT_SUCCESS,
  APP_CONTENT_FAILED
} from '../actions/appContentActions'

import AppContentManager from '../../util/AppContentManager'

const AppContent = (
  state = {
    isLoading: false,
    error: null,
    // Restore previously saved content:
    appContent: new AppContentManager(AppContentManager.restoreAppContent())
  }, action) => {
  switch (action.type) {
    case APP_CONTENT_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null
      }
    case APP_CONTENT_SUCCESS:
      // Convert the new content from the API response to the expected format:
      const content = AppContentManager.appContentFromResponse(action.response)
      // Save the new content to local storage:
      AppContentManager.saveAppContent(content)

      return {
        ...state,
        isLoading: false,
        appContent: new AppContentManager(content),
        error: null
      }
    case APP_CONTENT_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    default:
      return state
  }
}

export default AppContent



// WEBPACK FOOTER //
// ./src/redux/reducers/appContentReducer.js